<loading class="full">
  <ng-container> redirecting...</ng-container>
</loading>
